import { AVAILABLE_WORLDS } from '../languages/constants';

const personalizationConfig = {
    toBeShownInWorlds: [AVAILABLE_WORLDS.DE, AVAILABLE_WORLDS.ES, AVAILABLE_WORLDS.FR]
};

export default personalizationConfig;
